import { LabelId, UserCommunication } from '@this+that/models';

export const useHasSelectedDraftItems = (
  communications: UserCommunication[],
  selectedItems: Set<string>,
) => {
  const hasSelectedDraftItems = () => {
    const selectedCommunications = communications.filter((comm) =>
      selectedItems.has(comm.messageId),
    );
    return selectedCommunications.some((comm) =>
      comm.labelIds?.includes(LabelId.DRAFT),
    );
  };

  const isDraftItemSelected = hasSelectedDraftItems();

  return { isDraftItemSelected };
};
